import type { TOC } from '@ember/component/template-only';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { PrismLoadingBar, PrismModal } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelStrategyTablesTableDetailPosition from 'lumen/components/hotel/strategy/tables/table-detail-position';
import type HotelStrategyPositionController from 'lumen/controllers/hotel/strategy/position';

interface HotelStrategyPositionSignature {
  Args: {
    controller: HotelStrategyPositionController;
    model: unknown;
  };
}

<template>
  <PrismModal
    @onClose={{@controller.redirectOnClose}}
    @title={{t "strategy.average_best_available_rate"}}
    {{didInsert @controller.resetContainerDimensions}}
  >
    <div class="modal--stretched">
      {{#if @controller.isLoading}}
        <PrismLoadingBar @isFixed={{true}} @positionTop={{60}} />
      {{else if @controller.canRender}}
        <HotelStrategyTablesTableDetailPosition
          @initialSorts={{@controller.initialSorts}}
          @onTableSort={{@controller.onTableSort}}
          {{! @glint-expect-error: Incorrect type }}
          @positionDataPerHotelInfo={{@controller.positionDataPerHotelInfo}}
          @sortFunction={{@controller.sortFunction}}
        />
      {{/if}}
    </div>
  </PrismModal>
</template> satisfies TOC<HotelStrategyPositionSignature>;
